import React, { memo } from "react";
import { Box } from "@material-ui/core";
import { ReadOnlyField } from "components/SchemaProvider";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getOrderNumber } from "store/features/materialSpecs/specs";

interface BasicHeaderProps {
    bookedDimensions?: string;
    dimensions?: string;
    modificationDate?: string;
}

const BasicHeader = ({ bookedDimensions = "", dimensions = "", modificationDate = "" }: BasicHeaderProps) => {
    const { t } = useTranslation();
    const orderNumber = useSelector(getOrderNumber);

    return (
        <Box display="flex" justifyContent="space-between">
            <ReadOnlyField caption={t("campaign.label.orderNo")} label={orderNumber} bold />
            <ReadOnlyField caption={t("campaign.label.bookedDimensions")} label={bookedDimensions} bold />
            <ReadOnlyField caption={t("campaign.label.dimensions")} label={dimensions} bold />
            <ReadOnlyField caption={t("campaign.label.publicationDate")} label={modificationDate} bold />
        </Box>
    );
};

export default memo(BasicHeader);
